import 'core-js/stable';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { BootstrapVue, BootstrapVueIcons, IconsPlugin } from 'bootstrap-vue'
import { iconsSet as icons } from './assets/icons/icons.js';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-loading-overlay/dist/vue-loading.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import lodash from 'lodash'
import axios from 'axios';
import store from './store';
import helper from './helper';
import Loading from 'vue-loading-overlay';
import Multiselect from 'vue-multiselect';
import VueSkeletonLoader from 'skeleton-loader-vue';
import VueMoment from 'vue-moment';
import VueApexCharts from 'vue-apexcharts'

library.add(faEye)
library.add(faPlus)
library.add(faEdit)

Vue.config.productionTip = false
var token = localStorage.getItem("token");
// axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.baseURL = "http://ai-dev.inergi.id:8000/";
axios.defaults.timeout = 120000;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';

// token validity duration set to 23 hours (BE at 24 hours)
// const TOKEN_DURATION = 82800000
// token timestamp set at 24 hours, FE offsets by 1 hour early
const TOKEN_OFFSET = 3600000
// file upload size limit at 1000000 bytes or 1 MB
const UPLOAD_LIMIT = 1000000
// available login roles
const AVAIL_ROLES = {
  "Admin": 1,
  "Second": 2,
  "Third": 3,
  "Fourth": 4,
  "Fifth": 5,
}
// commonly used keywords
const TOKEN_KEYWORD = "cctvToken"
const TOKEN_CLOCK_KEYWORD = "cctvTokenClock"
const USER_ID_KEYWORD = "cctvUserId"
const USER_NAME_KEYWORD = "cctvUserName"
const EMAIL_KEYWORD = "cctvEmail"
const ROLE_ID_KEYWORD = "cctvRoleId"
const ROLE_NAME_KEYWORD = "cctvRoleName"

router.beforeEach((to, from, next) => {
  const basicRoutes = [
    'Login',
    // 'Register',
    // 'Forgot Password',
    // 'Account Activation'
  ]
  const allowedRoutesAdmin = [
    'Home',
    'Reports',
    'Cameras',
    'Users',
    'Profile',
    'VehicleList',
    'VehicleTracker',
    'Demo'
  ]
  const allowedRoutesSecond = [
    'Home',
  ]
  const allowedRoutesThird = [
    'Home',
  ]
  const allowedRoutesFourth = [
    'Home',
  ]

  // NOTE: check token expiry if already logged in
  // const tokenClock = localStorage.getItem(TOKEN_CLOCK_KEYWORD);
  // if (tokenClock){
  //   // get current time + FE TOKEN_OFFSET (1 hour)
  //   const now = new Date().getTime() + TOKEN_OFFSET
  //   // if current time + offset has passed BE token timestamp (24 hours) since last login
  //   if(now > tokenClock){
  //     axios.defaults.headers.common['Authorization'] = ""
  //     localStorage.removeItem(TOKEN_CLOCK_KEYWORD)
  //     localStorage.removeItem(TOKEN_KEYWORD)
  //     return next({ name:'Login' })
  //   }
  // }

  token = localStorage.getItem(TOKEN_KEYWORD); //Don't use global token above;
  axios.defaults.headers.common['Authorization'] = token;
  // always allow access to 404
  if (to.name == "Page 404"){
    return next()
  }
  // check before accessing basic routes
  else if (basicRoutes.includes(to.name)){
    // redirect if already logged in
    if(token){
      return next({ name: 'Home' })
    }
    // allow if not yet logged in
    else{
      return next()
    }
  }
  // check before accessing routes requiring login
  else{
    // check role access if logged in
    if(token){ // NOTE: CHANGE IT TO `if (token)` IN PRODUCTION!
      // for role HO, if route is not allowed
      if(AVAIL_ROLES["Admin"] == localStorage.getItem(ROLE_ID_KEYWORD) && !allowedRoutesAdmin.includes(to.name)){
        return next({ name: 'Page 404', params: { pathMatch: to.path } })
      }
      // // for role Second, if route is not allowed
      // else if(AVAIL_ROLES["Second"] == localStorage.getItem(ROLE_ID_KEYWORD) && !allowedRoutesSecond.includes(to.name)){
      //   return next({ name: 'Page 404', params: { pathMatch: to.path } })
      // }
      // // for role Third, if route is not allowed
      // else if(AVAIL_ROLES["Third"] == localStorage.getItem(ROLE_ID_KEYWORD) && !allowedRoutesThird.includes(to.name)){
      //   return next({ name: 'Page 404', params: { pathMatch: to.path } })
      // }
      // // for role Fourth, if route is not allowed
      // else if(AVAIL_ROLES["Fourth"] == localStorage.getItem(ROLE_ID_KEYWORD) && !allowedRoutesFourth.includes(to.name)){
      //   return next({ name: 'Page 404', params: { pathMatch: to.path } })
      // }
      // if route is allowed
      else{
        return next()
      }
    }
    else if(to.name == "Demo"){
      return next()
    }
    // return to login if not yet logged in
    else{
      axios.defaults.headers.common['Authorization'] = ""
      // localStorage.removeItem(TOKEN_CLOCK_KEYWORD)
      localStorage.removeItem(TOKEN_KEYWORD)
      localStorage.removeItem(USER_ID_KEYWORD)
      // localStorage.removeItem(USER_NAME_KEYWORD)
      localStorage.removeItem(EMAIL_KEYWORD)
      localStorage.removeItem(ROLE_ID_KEYWORD)
      // localStorage.removeItem(ROLE_NAME_KEYWORD)
      return next({ name: 'Login' })
    }
  }
})
let errorLabel = {
  generic: 'Error!',
  emptyField: '-'
};

Vue.use(CoreuiVue);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);
Vue.use(VueMoment);
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('Loading', Loading)
Vue.component('Multiselect', Multiselect);
Vue.component('Skeleton', VueSkeletonLoader);
Vue.component('FaIcon', FontAwesomeIcon)
Vue.prototype.$lodash = lodash;
Vue.prototype.$axios = axios;
Vue.prototype.$helper = helper;
Vue.prototype.$errorLabel = errorLabel;
Vue.prototype.$appType = 'CCTV_';
Vue.prototype.$realm = 'cctv';
Vue.prototype.$uploadLimit = UPLOAD_LIMIT;
Vue.prototype.$availRoles = AVAIL_ROLES;
Vue.prototype.$tokenKeyword = TOKEN_KEYWORD;
// Vue.prototype.$tokenClockKeyword = TOKEN_CLOCK_KEYWORD;
Vue.prototype.$userIdKeyword = USER_ID_KEYWORD;
// Vue.prototype.$userNameKeyword = USER_NAME_KEYWORD;
Vue.prototype.$emailKeyword = EMAIL_KEYWORD;
Vue.prototype.$roleIdKeyword = ROLE_ID_KEYWORD;
// Vue.prototype.$roleNameKeyword = ROLE_NAME_KEYWORD;

const rootApp = new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App></App>',
  components: {
    App,
  },
});

rootApp;
